export { FAQList } from './index.pc'
export { MobileFAQList } from './index.mobile'
